
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
export default {
  props: ["data"],
  setup(props, { emit }) {
    const seasons: any = ref(props.data);
    const store = useStore();
    store.dispatch(Actions.SEASON_LIST);
    const seasonList = computed(
      () => store.state.SeasonModule.season.value || []
    );

    const onChange = (args) => {
      emit("changeSeason", args);
    };
    return { close, seasons, store, seasonList, onChange };
  },
};
